import React from 'react';

const featuredItem = ( props ) => {
   let doctor = '';
   if("doctor" in props.itemData) {
      doctor = (
         <h3>{props.itemData.doctor}</h3>
      );
   }

   return (
      <div className="wn_item">
         <a target="_blank" href={props.itemData.link}>
            <img src={props.itemData.image} />
            {doctor}
            <h3>{props.itemData.title}</h3>
         </a>
      </div>
   );


};

export default featuredItem;


// WEBPACK FOOTER //
// ./src/components/FeaturedItem/FeaturedItem.js